import { AppointmentSetup } from "../../../../models/site-setup.interface";
import { useSiteContext } from "../../../../context/siteContext";
import useApiService from "../../../../hooks/useApiService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { MultiSelect } from "../../../../components/Shared/Forms";
import { Button } from "primereact/button";
import { CancelIcon, CheckIcon, CircleWarning, InfoCircleIcon } from "../../../../assets/icons";

export function AppointmentsPanel() {
  const { site } = useSiteContext();
  const [modalToView, setModalToView] = useState<"assign-employee" | null>(null);
  const [selectedAppointment, setSelectedAppointment] = useState<AppointmentSetup | null>(null);
  const {
    data,
    loading,
    fetchData: fetchSiteSetup,
  } = useApiService<AppointmentSetup[]>({
    url: "site-setup",
    params: {
      siteId: site?.id || "",
    },
    method: "GET",
    apiName: "core",
  });

  const { data: employees, loading: loadingEmployees } = useApiService<
    { full_name: string; id: string; name: string; surname: string }[]
  >({
    url: "employee-select",
    method: "GET",
    apiName: "core",
  });

  const { fetchData: assignEmployee, loading: assigningEmployee } = useApiService({
    url: "site-setup",
    method: "POST",
    apiName: "core",
    fetchOnMount: false,
    onSuccess: async () => {
      setModalToView(null);
      await fetchSiteSetup();
    },
  });

  function handleRowClick(e: any) {
    setModalToView("assign-employee");
    setSelectedAppointment(e.data);
  }

  function handleSelectionChange(item: { label: string; value: string }) {
    const employees = selectedAppointment?.employee || [];
    const isSelected = employees.includes(item.value);
    if (isSelected) {
      setSelectedAppointment({
        ...selectedAppointment!,
        employee: employees.filter(emp => emp !== item.value),
      });
      return;
    }

    if (selectedAppointment) {
      setSelectedAppointment({
        ...selectedAppointment,
        employee: [...employees, item.value],
      });
    }
  }

  async function saveAssignment() {
    if (selectedAppointment) {
      await assignEmployee({
        payload: {
          employee: selectedAppointment.employee,
          appointment: selectedAppointment.id,
          site_id: site?.id,
        },
      });
    }
  }

  const renderAppointmentAssigned = (row: AppointmentSetup) => {
    if (row.appointment_assigned) {
      return <CheckIcon fill={"#2DD36FFF"} />;
    }
    return <CancelIcon fill={"#EB445AFF"} />;
  };

  return (
    <div>
      <DataTable
        loading={loading}
        value={data ?? []}
        className={`policies-procedures-table`}
        tableStyle={{ minWidth: "50rem" }}
        onRowClick={handleRowClick}
      >
        <Column field={"name"} header={"Appointment Name"} style={{ minWidth: "12rem" }} />
        <Column
          field={"legal_reference"}
          header={"Legal Reference"}
          style={{ minWidth: "12rem" }}
        />
        <Column
          field={"type"}
          header={"Type"}
          style={{ minWidth: "12rem" }}
        />
        <Column
          field={"type_name"}
          header={"Item"}
          style={{ minWidth: "12rem" }}
        />
        <Column
          field={"appointment_assigned"}
          header={"Appointment Assigned"}
          body={renderAppointmentAssigned}
          align={"center"}
        />
        <Column field={"employee_list"} header={"Employee"} />
      </DataTable>
      <Dialog
        onHide={() => setModalToView(null)}
        header={"Assign Appointment"}
        visible={!!modalToView}
        style={{ width: "50vw", maxWidth: "760px" }}
        modal
      >
        <div className={"mt-4"}>
          <MultiSelect
            options={
              employees?.map(employee => ({
                label: employee.full_name,
                value: employee.id,
              })) || []
            }
            label={"Select Employees"}
            value={selectedAppointment?.employee || []}
            onChange={(val: any) => {
              handleSelectionChange(val.selectedOption as { label: string; value: string });
            }}
            loading={loadingEmployees}
            onSelectAll={(val: any) => {
              if (selectedAppointment) {
                setSelectedAppointment({
                  ...selectedAppointment,
                  employee: val,
                });
              }
            }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "1rem",
              background: "white",
              paddingTop: "1rem",
              borderTop: "1px solid #e5e7eb",
              flexShrink: 0,
            }}
          >
            <Button
              color={"primary"}
              onClick={async () => {
                await saveAssignment();
              }}
              label={"Save"}
              loading={assigningEmployee}
              disabled={assigningEmployee}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
